import { Unidade } from 'src/app/core/unidade';
export class CadastroAcesso {

    idUsuario: number;
    idModulo: number;
    idInstituicao: number;
    idPerfilAcesso: number;
}
